// extracted by mini-css-extract-plugin
var _1 = "DszLO__heading";
var _2 = "DszLO__selection";
export { _1 as "heading", _2 as "selection" }
